module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp123_3.1846bd74.png";